import React from 'react';
import { useGlobalStore } from 'lib/store';
import './index.scss';

const PackageInfo = () => {
  const packageInfoList = useGlobalStore(state => state.smsModalPackageInfoList);

  return (
    <div className="package-info">
      <div className="package-info__scroll">
        {packageInfoList.map(({ label, value }) => (
          <div className="package-info__row" key={label}>
            <span className="package-info__label">{label}</span>
            <span className="package-info__value">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageInfo;
